import React from "react";
import PropTypes from "prop-types";
import EmptyField from "UIComponents/EmptyField";
import UIBaseComponent from "UIComponents/UIBaseComponent";

class EmptyComponent extends UIBaseComponent {
  constructor(props) {
    super(props);
  }

  shouldShowEmpty = () => {
    return true;
  };

  renderEditEmpty = () => {
    const { emptyText } = this.props;

    return <EmptyField title={emptyText} />;
  };
}

EmptyComponent.propTypes = {
  ...UIBaseComponent.propTypes,
  emptyText: PropTypes.string,
};

EmptyComponent.defaultProps = {
  ...UIBaseComponent.defaultProps,
  emptyText: "",
};

export default EmptyComponent;
